import { GetOneExpeditionBoResponseDto } from "@/types/api/api-types";
import { useTranslation } from "react-i18next";
import { Element } from "@/components/validatedShipments/element";

type ParcelDetailProps = {
  expedition: GetOneExpeditionBoResponseDto;
};

export const ParcelDetail = ({ expedition }: ParcelDetailProps) => {
  const { t } = useTranslation("boQuotations");
  const parcelProducts = expedition.customQuotation?.parcelDetail?.parcelProducts;
  const parcelPackages = expedition.customQuotation?.parcelDetail?.parcelPackages;

  return (
    <div className="flex w-full flex-col gap-6">
      <div className="flex w-full flex-col gap-2">
        {parcelProducts?.map((parcelProducts, index) =>
          parcelProducts.type === "BOTTLE" ? (
            <Element
              key={index}
              title={t("parcelDetail.productTitle", { number: index + 1 })}
              value={t("parcelDetail.bottles", {
                quantity: parcelProducts.bottleQuantity,
                volume: parcelProducts?.volume ?? 0,
              })}
            />
          ) : (
            <Element
              key={index}
              title={t("parcelDetail.productTitle", { number: index + 1 })}
              value={`${parcelProducts.description}`}
            />
          ),
        )}
        <div className="grid w-full grid-cols-2 justify-between">
          <div className="flex w-fit flex-row gap-4">
            <input
              type="checkbox"
              className="peer w-[16px]"
              checked={expedition.expeditionOptions?.insurance}
              readOnly
            />
            <label className="text-sm font-medium text-gray-700">
              {t("parcelDetail.insuranceLabel")}
            </label>
          </div>
          <div className="flex w-fit flex-row gap-4">
            <input
              type="checkbox"
              className="peer w-[16px]"
              checked={expedition.expeditionOptions?.express}
              readOnly
            />
            <label className="text-sm font-medium text-gray-700">
              {t("parcelDetail.expressLabel")}
            </label>
          </div>
        </div>
        {parcelPackages?.map((parcelPackage, index) => (
          <>
            <Element
              key={index + "dimensions"}
              title={t("parcelDetail.dimensionsTitle", { number: index + 1 })}
              value={t("parcelDetail.dimensionsValue", {
                height: parcelPackage.height,
                length: parcelPackage.length,
                width: parcelPackage.width,
              })}
            />
            <Element
              key={index + "weight"}
              title={t("parcelDetail.weightTitle", { number: index + 1 })}
              value={`${parcelPackage.weight} kg`}
            />
            <Element
              key={index + "value"}
              title={t("parcelDetail.valueTitle", { number: index + 1 })}
              value={`${parcelPackage.value} €`}
            />
          </>
        ))}
      </div>
    </div>
  );
};
